<template>
  <div>
    <!-- Nav tabs -->
    <ul
      class="nav nav-tabs"
      :class="{ 'nav-justified': justified }"
      role="tablist"
    >
      <slot name="tabs"></slot>
    </ul>

    <!-- Tab panes -->
    <div class="tab-content">
      <slot name="panes"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "horizontal-tabs",
  props: {
    justified: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/UIComponents/Tabs/HorizontalTabs.vue